import { Component, Input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CustomizerSettingsService } from '../../../../customizer-settings/customizer-settings.service';
import { TranslocoModule } from '@ngneat/transloco';
import { DecimalPipe } from '@angular/common';
import { Email, ScanHistory } from '../../../../interfaces/asm/models';
import { AsmService } from '../../../../services/asm/asm.service';
import { QueryEmailsResponse } from '../../../../interfaces/asm/QueryEmailsResponse';
import { QueryEmployeesResponse } from '../../../../interfaces/asm/QueryEmployeesResponse';

@Component({
    selector: 'app-osint',
    standalone: true,
    imports: [MatCardModule, MatTooltipModule, TranslocoModule, DecimalPipe],
    templateUrl: './osint.component.html',
    styleUrl: './osint.component.scss',
})
export class OsintComponent {
    // isToggled
    isToggled = false;

    @Input() scan: ScanHistory;
    osint: boolean = false;
    exposedCount: number = 0;
    emailCount: number = 0;
    employeesCount: number = 0;

    constructor(
        public themeService: CustomizerSettingsService,
        private asmService: AsmService
    ) {
        this.themeService.isToggled$.subscribe((isToggled) => {
            this.isToggled = isToggled;
        });
    }

    // Dark Mode
    toggleTheme() {
        this.themeService.toggleTheme();
    }

    // changeData
    changeData() {
        this.osint =
            this.scan.tasks != undefined &&
            this.scan.tasks != null &&
            this.scan.tasks.includes('osint');
        this.asmService
            .getQueryEmails(this.scan.id)
            .subscribe((response: QueryEmailsResponse) => {
                this.emailCount = response.emails.length;
                this.exposedCount = response.emails.filter(
                    this.checkPasswordIsNull
                ).length;
                this.asmService
                    .getQueryEmployees(this.scan.id)
                    .subscribe((response: QueryEmployeesResponse) => {
                        this.employeesCount = response.employees.length;
                    });
            });
    }

    // checkPasswordIsNull
    private checkPasswordIsNull(email: Email) {
        return email.password === undefined || email.password === null;
    }
}
